import { globals } from '@/constants';

export const isPromotionCompleted = () => {
    const currentDate = Date.now();
    return globals.PROMOTION_DATE_END < currentDate;
};

export default isPromotionCompleted;